.illustration-container {
    width: 200px;
    height: 200px;
}

.description {
    text-align: center;
}
